<template>
  <svg class="sprite-icon">
    <vue-client-only>
      <use :xlink:href="`#${iconLink}`" />
    </vue-client-only>
  </svg>
</template>

<script>
import VueClientOnly from 'vue-client-only';

export default {
  name: 'sprite-icon',
  components: {
    VueClientOnly,
  },
  props: {
    /**
     * Ссылка на иконку в спрайте
     */
    iconLink: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .sprite-icon {
    display: block;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
</style>

<docs>
  Спрайт с иконками генерируется автоматически на основании импортов.

  *** Использование ***

  ```javascript
  import IconTest from '../../assets/icons/icon-test.svg' // импорт в режиме current color (default)
  import IconTest from '../../assets/icons/icon-test.multi.svg' // импорт в режиме multi color

  export default {
    ....
    icons: {
      IconTest
    },
    ....
  }
  ```

  ```html
    <sprite-icon :icon-link="$options.icons.IconTest.id"/>
  ```
</docs>
